import { useQuery } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../../core/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { getSlaMetricsMeasurement } from '../../api';
import { SlaMonitoredServicesHttpQuery } from '../../config';
import {
  mapSlaMetricsMeasurementApiModelToSlaMetricsMeasurementViewModel,
  SlaMetricsMeasurementViewModel,
} from '../../model';

export interface SlaMetricsMeasurementApiGetHookResult {
  measurement?: SlaMetricsMeasurementViewModel,
  isFetching: boolean;
  isFetched: boolean;
}

export const useSlaMetricsMeasurementApiGet = (
  customerId: number,
  itemId: number,
  cosId: number,
  chartSettings: ChartSettings,
  customQueryKeyPhrase: string,
): SlaMetricsMeasurementApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const { data, isFetching, isFetched } = useQuery({
    queryKey: [
      SlaMonitoredServicesHttpQuery['GetSlaMetricsMeasurement'].key,
      customerId,
      itemId,
      cosId,
      chartSettings,
      customQueryKeyPhrase,
    ],
    queryFn: async () => {
      const apiMeasurement = await getSlaMetricsMeasurement(axios, { customerId, cosId, itemId, chartSettings });
      return mapSlaMetricsMeasurementApiModelToSlaMetricsMeasurementViewModel(apiMeasurement);
    },
    structuralSharing: false,
    gcTime: 300000,
    staleTime: 5000,
  });
  return { measurement: data, isFetching, isFetched };
};